<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z" />
    </svg> -->
    <path d="M8 25.3333C8 26.8 9.2 28 10.6667 28H21.3333C22.8 28 24 26.8 24 25.3333V9.33334H8V25.3333Z" />
    <path d="M20.6667 5.33333H25.3333V8H6.66667V5.33333H11.3333L12.6667 4H19.3333L20.6667 5.33333Z" :class="$style.on" />
  </svg>
</template>

<style module>
.on {
  transition: transform 120ms var(--tran3);
}
:global(.IconTrash):hover .on {
  transform: rotate(-12deg) translate(-2px, 2px);
}
</style>
